import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-wisconsin-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./wisconsin-state-form.component.html",
  styleUrl: "./wisconsin-state-form.component.scss",
})
export class WisconsinStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
